import HelpApi from '@/api/help/common';
import {ObjectionStatusResponse} from './type';

export const getObjectionStatus = (): Promise<ObjectionStatusResponse> => {
  return HelpApi.post('api/get_objection_status.php',{}, {});
};
